const OPP_STATUSES = {
  NEW: 'NEW',
  QUALIFICATION: 'QUALIFICATION',
  NEGOTIATION: 'NEGOTIATION',
  LEGAL_REVIEW: 'LEGAL_REVIEW',
  CONFIRMED: 'CONFIRMED',
  ONBOARDING: 'ONBOARDING',
  ACTIVE: 'ACTIVE',
  DECLINED: 'DECLINED',
  POSTPONED: 'POSTPONED',
};

export const OPP_STATUS_LABELS = {
  [OPP_STATUSES.NEW]: 'New',
  [OPP_STATUSES.QUALIFICATION]: 'Qualification',
  [OPP_STATUSES.NEGOTIATION]: 'Negotiation',
  [OPP_STATUSES.LEGAL_REVIEW]: 'Legal review',
  [OPP_STATUSES.CONFIRMED]: 'Confirmed',
  [OPP_STATUSES.ONBOARDING]: 'Onboarding',
  [OPP_STATUSES.ACTIVE]: 'Active',
  [OPP_STATUSES.DECLINED]: 'Declined',
  [OPP_STATUSES.POSTPONED]: 'Postponed',
};
